import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
export const searchClassifieds = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchClassifieds.url(options),
    method: 'get',
})

searchClassifieds.definition = {
    methods: ["get","head"],
    url: '/api/listings/search-classifieds',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
searchClassifieds.url = (options?: RouteQueryOptions) => {
    return searchClassifieds.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
searchClassifieds.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchClassifieds.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
searchClassifieds.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchClassifieds.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
const searchClassifiedsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchClassifieds.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
searchClassifiedsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchClassifieds.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingController::searchClassifieds
* @see app/Http/Controllers/ListingController.php:49
* @route '/api/listings/search-classifieds'
*/
searchClassifiedsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchClassifieds.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

searchClassifieds.form = searchClassifiedsForm

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/empresas',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::index
* @see app/Http/Controllers/ListingCategoryRouteController.php:62
* @route '/empresas'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
export const classifieds = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: classifieds.url(args, options),
    method: 'get',
})

classifieds.definition = {
    methods: ["get","head"],
    url: '/empresas/{slug}/embarcacoes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
classifieds.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return classifieds.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
classifieds.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: classifieds.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
classifieds.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: classifieds.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
const classifiedsForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: classifieds.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
classifiedsForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: classifieds.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingClassifiedsController::classifieds
* @see app/Http/Controllers/ListingClassifiedsController.php:56
* @route '/empresas/{slug}/embarcacoes'
*/
classifiedsForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: classifieds.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

classifieds.form = classifiedsForm

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
export const show = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/empresas/{path}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
show.url = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { path: args }
    }

    if (Array.isArray(args)) {
        args = {
            path: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        path: args.path,
    }

    return show.definition.url
            .replace('{path}', parsedArgs.path.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
show.get = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
show.head = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
const showForm = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
showForm.get = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingCategoryRouteController::show
* @see app/Http/Controllers/ListingCategoryRouteController.php:39
* @route '/empresas/{path}'
*/
showForm.head = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const listings = {
    searchClassifieds: Object.assign(searchClassifieds, searchClassifieds),
    index: Object.assign(index, index),
    classifieds: Object.assign(classifieds, classifieds),
    show: Object.assign(show, show),
}

export default listings